import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';

export default function Tags(props) {
  return (
    <div>
    <ComponentErrorBoundary value="select env autocomplete">
      <Autocomplete
        autoHighlight
        disableClearable={true}
        options={props.fileColumns}
        getOptionLabel={option =>  option.envTypeName || option.envName+" ("+option.envTypeName+")"|| option.name || option }
        value={props.value}
        onChange={(event, newValue) => {props.onSelectValue(newValue);}}
        renderInput={params => {
          return (
            <TextField
              {...params}
              variant="standard"
              label={props.label}
              error={props.errorStatus}
              helperText={props.errorText}
              margin="normal"
              fullWidth
            />
          );
        }}
      />
     </ComponentErrorBoundary>
    </div>
  );
}
